import React, { Fragment } from 'react';

import Divider from '@/components/common/Divider';
import ProductCard from '@/components/categ/CategCU/ProductCard';
import Push from '@/components/common/design-system/Push.ds';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

import styles from './ProductListCU.module.scss';
import { VirtualAssistantButton } from '@/components/virtual-assistant/virtual-assistant-button';
import { startAssistantConversation } from '@/redux/slices/assistant.slice';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { isFeatureEnabled } from '@/utils/millesimaUtils';
import { useAppSelector } from '@/redux';

export const ProductListCU = ({
  productList,
  computeCurrentItem,
  espotPush = null,
  showUnitBloc = true,
  visibilityTracking
}) => {
  const screenSizes = useScreenSizeContext();
  const storeConf = useAppSelector(({ root })=> root.storeConf);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const insertionRules = {
    desktop: 4,
    tablet: 3,
    mobile: 2,
  };

  const insertAfter =
    (screenSizes.isDesktop && insertionRules.desktop) ||
    (screenSizes.isTablet && insertionRules.tablet) ||
    (screenSizes.isMobile && insertionRules.mobile);

  const dividerModulo = screenSizes.isMobile ? 2 : screenSizes.isDesktop ? 4 : 3;

  const finalList = Array.isArray(productList) ? [...productList] : [];
  if (isFeatureEnabled(storeConf, 'chatbot')) {
    if (screenSizes.isMobile) {
      finalList.splice(3, 0, { id: 'assistant' });
    } else {
      finalList.splice(insertAfter - 1, 0, { id: 'assistant' });
    }
  }

  return (
    <div className={styles.container} data-test-id="product-list-cu">
      {finalList?.map((product, index) => {
        if (product.id === 'assistant') {
          return (
            <>
              <div key={product.id} className={styles.assistant}>
                <p className={styles.title}>{t('assistant.catalogPage.title')}</p>
                <p className={styles['sub-title']}>
                  {t('assistant.catalogPage.subTitle')}
                </p>
                <VirtualAssistantButton
                  size="md" onClick={() => dispatch(startAssistantConversation())} label={t('assistant.name')}
                />
              </div>
              {index === insertAfter - 1 && espotPush && (
                <>
                  <Divider spacing={16} className={styles.divider} />
                  <div className={styles['espot-push']}>
                    <Push {...espotPush} />
                  </div>
                </>
              )}
            </>
          );
        }
        return (
          <Fragment key={index}>
            {index % dividerModulo === 0 && <Divider spacing={16} className={styles.divider} />}
            <div key={product.id} className={styles.card}>
              <ProductCard
                product={product}
                index={index}
                item={computeCurrentItem(product)}
                showUnitBloc={showUnitBloc}
                visibilityTracking={visibilityTracking}
              />
            </div>

            {index === insertAfter - 1 && espotPush && (
              <>
                <Divider spacing={16} className={styles.divider} />
                <div className={styles['espot-push']}>
                  <Push {...espotPush} />
                </div>
              </>
            )}
          </Fragment>
        );
      })}
      <Divider spacing={16} className={styles.divider} />
    </div>
  );
};

export default ProductListCU;
